import { render } from "./ItemRow.vue?vue&type=template&id=f2ecc0f0"
import script from "./ItemRow.vue?vue&type=script&lang=ts"
export * from "./ItemRow.vue?vue&type=script&lang=ts"
script.render = render

export default script